import type { ExtractPropTypes, PropType, Component, CSSProperties } from 'vue'
import type _Statistic from './statistic.vue'

export const sdStatisticProps = {
    title           : { type: String                                           }, // 标题
    value           : { type: [String, Number] as PropType<string | number>    }, // 数值内容
    valueStyle      : { type: Object as PropType<CSSProperties>                }, // 数值内容
    decimalSeparator: { type: String, default: '.'                             }, // 设置小数点
    groupSeparator  : { type: String, default: ','                             }, // 千分位符号
    precision       : { type: Number                                           }, // 数值精度
    prefix          : { type: [String, Object] as PropType<string | Component> },       
    suffix          : { type: [String, Object] as PropType<string | Component> },       
} 

export type SdStatisticProps    = ExtractPropTypes<typeof sdStatisticProps>
export type SdStatisticInstance = InstanceType<typeof _Statistic>


